import { Link } from "react-router-dom";

/**
 * Footer premium con links legales. Reutilizable en Landing y área privada.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 md:mt-24 border-t border-slate-200 bg-white/60 print-hide" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-8 md:py-10 flex flex-col md:flex-row items-center md:items-start justify-between gap-6">
        <div className="text-center md:text-left">
          <div className="font-display text-sm font-semibold" style={{ color: "#0b3d2e" }}>Talent Health Check</div>
          <div className="text-[11px] text-slate-500 mt-1">by OptimizaRRHH · Consultoría de gestión del talento</div>
          <div className="text-[10px] text-slate-400 mt-2">© {year} OptimizaRRHH. Todos los derechos reservados.</div>
        </div>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[12px] font-medium text-slate-600" aria-label="Enlaces legales">
          <Link to="/legal/terminos" className="hover:text-[#0F6E56] transition-colors" data-testid="footer-link-terms">Términos y condiciones</Link>
          <Link to="/legal/privacidad" className="hover:text-[#0F6E56] transition-colors" data-testid="footer-link-privacy">Política de privacidad</Link>
          <Link to="/legal/cookies" className="hover:text-[#0F6E56] transition-colors" data-testid="footer-link-cookies">Cookies</Link>
          <a href="mailto:hola@talenthealthcheck.com" className="hover:text-[#0F6E56] transition-colors" data-testid="footer-link-contact">Contacto</a>
        </nav>
      </div>
    </footer>
  );
}
